import { create } from 'zustand';
import type { Course } from '../mocks/courses';

interface CoursesState {
  courses: Course[];
  isLoaded: boolean;
  loading: boolean;
  setCourses: (courses: Course[]) => void;
  setLoading: (loading: boolean) => void;
  addCourse: (course: Course) => void;
  updateCourse: (id: string, course: Partial<Course>) => void;
  deleteCourse: (id: string) => void;
  toggleActive: (id: string) => void;
  getCourseById: (id: string) => Course | undefined;
  getActiveCourses: () => Course[];
  getActiveCareers: () => Course[];
  refreshCourses: () => void;
}

export const useCoursesStore = create<CoursesState>((set, get) => ({
  courses: [],
  isLoaded: false,
  loading: false,

  setCourses: (courses) => {
    set({ courses, isLoaded: true, loading: false });
  },

  setLoading: (loading) => {
    set({ loading });
  },

  addCourse: (course) => {
    set((state) => ({
      courses: [...state.courses, course],
    }));
  },

  updateCourse: (id, updatedData) => {
    set((state) => ({
      courses: state.courses.map((course) =>
        course.id === id ? { ...course, ...updatedData } : course
      ),
    }));
  },

  deleteCourse: (id) => {
    set((state) => ({
      courses: state.courses.filter((course) => course.id !== id),
    }));
  },

  toggleActive: (id) => {
    set((state) => ({
      courses: state.courses.map((course) =>
        course.id === id
          ? { ...course, active: !course.active }
          : course
      ),
    }));
  },

  getCourseById: (id) => {
    return get().courses.find((course) => course.id === id);
  },

  getActiveCourses: () => {
    return get().courses.filter(
      (course) => course.type !== 'carrera' && course.active !== false
    );
  },

  getActiveCareers: () => {
    return get().courses.filter(
      (course) => course.type === 'carrera' && course.active !== false
    );
  },

  refreshCourses: () => {
    set({ isLoaded: false });
  },
}));